export default "__VITE_ASSET__tnWcJWJf__"